<div class="progress">
    <div class="indicator"
        [ngStyle]="{'width': percent + '%', 'border-top-right-radius': percent === '100' ? '4px' : '0px', 'border-bottom-right-radius': percent === '100' ? '4px' : '0px'}">
    </div>
    <div class="label">{{title}}</div>
</div>